/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'iconPhone': {
    width: 300,
    height: 300,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 0C228.279 0 0 227.547 0 510.537S228.279 1024 512 1024c283.794 0 512-230.4 512-513.463S795.794 0 512 0zm228.425 738.304l-48.494 37.303c-45.933 13.604-159.085 35.84-299.593-162.45-159.085-214.455-95.597-335.872-72.045-357.01l50.98-35.84 21.065 6.216 85.797 123.831-2.414 19.968-49.81 34.67c-22.309 18.505-7.314 42.057 8.777 86.747 14.848 25.966 48.42 77.97 70.802 97.866 38.473 32.256 55.955 53.32 82.067 38.4l47.25-33.427 18.724 2.414 89.454 120.32-2.56 20.992zm0 0" _fill="#2D8CF0"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/iconPhone.js